import React from 'react';

import { TextField } from '@material-ui/core';
import useStyles from './styles';

const moveNoToEnd = (options) => [...options].sort(
  (a, b) => (a.name.toLowerCase() === 'no') - (b.name.toLowerCase() === 'no'),
);

const SelectAnswer = ({
  editableAnswer,
  setEditableAnswer,
  editableOptions,
  setEditableOptions,
  options = [],
  type,
}) => {
  const classes = useStyles();

  const isYesNo = type === 'yes/no question';
  const isMultiple = type === 'multiple selection';

  const sortedOptions = isYesNo ? moveNoToEnd(options) : options;

  const handleOnChange = (value) => {
    const currentList = editableOptions || [];

    if (isMultiple) {
      const isSelected = currentList.includes(value);

      if (isSelected) {
        setEditableOptions(currentList.filter((item) => item !== value));
      } else {
        setEditableOptions([...currentList, value]);
      }
    } else {
      setEditableOptions([value]);
    }
  };

  const handleOtherChange = (value) => {
    setEditableAnswer(value);
  };

  const otherInput = (label) => <div className={classes.otherInput}>
    <span>{label}</span>
    <TextField
      value={editableAnswer}
      multiline
      minRows={1}
      variant="standard"
      onChange={(e) => handleOtherChange(e.target.value)}
    />
  </div>;

  return (
    <div className={classes.content}>
      {sortedOptions.map((option, index) => (
        <label key={index} className={classes.optionLabel}>
          <input
            type={isMultiple ? 'checkbox' : 'radio'}
            name={!isMultiple ? 'selection' : undefined}
            value={option.value || ''}
            checked={(editableOptions || []).includes(option.value)}
            onChange={() => handleOnChange(option.value)}
          />
          {option.type !== 'other' && option.name}
          {option.type === 'other' && otherInput(option.name)}
        </label>
      ))}
    </div>
  );
};

export default SelectAnswer;
